<script>
    import Header from '@/components/_partials/Header'
    import Footer from '@/components/_partials/Footer'

    export default {
        components: {
            Header,
            Footer
        }
    }
</script>

<template>
    <div id="page-view">
        <Header />

        <div class="page-content">
            <slot />
        </div>

        <Footer />
    </div>
</template>